/**
 * @fileoverview
 * Utility function to detect locale from the browser setting or paramenter on the URL.
 */

import queryString from "query-string";

/**
 * look for language setting in the browser. Check against supported locales.
 * If there's a parameter in the URL, override the browser setting
 * @param {Array.string} supportedLocales An array of supported locale codes.
 * @return {string} the preferred locale
 */
const detectLocale = (supportedLocales) => {
    let locale = "en"; // default

    const queryParams = queryString.parse(location.search);
    // Flatten potential arrays and remove falsy values
    const potentialLocales = []
        .concat(queryParams.locale, queryParams.lang)
        .filter((l) => l);
    if (potentialLocales.length) {
        const urlLocale = potentialLocales[0].toLowerCase();
        if (supportedLocales.includes(urlLocale)) {
            return urlLocale;
        }
    }

    // Check localStorage
    const savedLocale =
        window.localStorage && window.localStorage.getItem("openblock-locale");
    if (savedLocale && supportedLocales.includes(savedLocale)) {
        return savedLocale;
    }

    let browserLocale =
        window.navigator.userLanguage || window.navigator.language;
    browserLocale = browserLocale.toLowerCase();
    // try to set locale from browserLocale
    if (supportedLocales.includes(browserLocale)) {
        locale = browserLocale;
    } else {
        browserLocale = browserLocale.split("-")[0];
        if (supportedLocales.includes(browserLocale)) {
            locale = browserLocale;
        }
    }

    return locale;
};

export { detectLocale };
